import styled from "styled-components";

import BackgroundPattern from "@images/loginBackgroundPattern.png";
import { Button } from "@mui/material";
import Colors from "@src/constants/Colors";

export const LoginBackgroundImage = styled.div`
  background: linear-gradient(
    to bottom,
    ${Colors.primary_700},
    ${Colors.primary},
    ${Colors.neutral_gray_200}
  );
  mix-blend-mode: multiply;
  height: 100vh;
  background-position: center;
`;

export const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100%;
`;

export const LoginBackgroundImageWrapper = styled.div`
  background: url(${BackgroundPattern});
`;

export const BackgroundImageMainWrapper = styled.div`
  position: absolute;
  z-index: -1;
  width: 100vw;
  height: 100vh;
`;

export const BackGroundImage = styled.img`
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const CustomCardHeading = styled.div`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 40px;
  color: ${Colors.primary_700};
`;

export const CustomCardSubHeading = styled.div`
  font-family: Ringside Regular-Book;
  font-style: normal;
  font-weight: 325;
  font-size: 16px;
  line-height: 24px;
  max-width: 302px;
  text-align: center;
  color: ${Colors.neutralblack};
`;

export const LoginPageDivider = styled.div`
  max-width: 347px;
  width: 90vw;
  margin: 21px 0;
`;

export const CustomLoginButton = styled(Button)`
  &.MuiButtonBase-root {
    margin: 36px 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 12px;
    max-width: 186px;
    width: 100vw;
    height: 46px;
    border: 1px solid ${Colors.primary_800};
    border-radius: 8px;
    background-color: ${Colors.primary_800};
    color: ${Colors.white};
    font-family: Ringside Regular-Bold;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    text-transform: capitalize;
    &:hover {
      background-color: ${Colors.primary_800};
      color: ${Colors.white};
    }
  }
`;

export const CustomLoginNote = styled.div`
  font-family: Ringside Regular-Book;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${Colors.neutralblack};
  max-width: 283px;
`;

export const LoginPageContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ContentWrapper = styled.div<{
  height: string;
}>`
  display: flex;
  justify-content: center;
  height: ${(props) => props.height}px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const LoginPageCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  max-width: 350px;
  border-radius: 12px;
  background: ${Colors.white};
  padding: 58px 0px;
`;

export const MainLogoWrapper = styled.div<{
  isDesktop: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  width: 90vw;
  max-width: 283px;
`;
